import { SingularityMetaV } from "@/types/document";
import * as t from "io-ts";

export const PageInWPV = t.intersection([
  t.type({
    id: t.number,
    title: t.string,
    relativeUrl: t.string,
    postType: t.string,
    singularityMeta: SingularityMetaV,
    generatingInBackground: t.boolean
  }),
  t.partial({
    isInMainMenu: t.boolean,
    menuOrder: t.union([t.number, t.null])
  })
]);

export type PageInWP = t.TypeOf<typeof PageInWPV>;
